import { createUseStyles } from 'react-jss';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { TextColors } from '@picsart/design-system/foundation/textColors';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Shadows } from '@picsart/design-system/foundation/shadows';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const useStyles = createUseStyles(
  {
    page: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      backgroundColor: BackgroundColors.base,
    },
    pageHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s4,
      padding: `0 ${Spacings.s4}`,
      backgroundColor: BackgroundColors.base,
      flexShrink: 0,
    },
    pageTitle: {
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l24,
      color: TextColors.base,
    },
    dropdown: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: 'calc(100% + 6px)',
      right: 0,
      backgroundColor: BackgroundColors.base,
      border: [1, 'solid', BackgroundColors.border],
      borderRadius: CornerRadius.r12,
      zIndex: StackingContext.PopoverLayer,
      width: 360,
      maxHeight: 620,
      overflowY: 'auto',
      boxShadow: Shadows.tint2,
    },
    dropdownHeader: {
      padding: `${Spacings.s12} ${Spacings.s16} ${Spacings.s4}`,
    },
    content: {
      flex: 1,
      overflowY: 'auto',
      padding: `${Spacings.s8} ${Spacings.s12}`,
    },
    section: {
      marginBottom: Spacings.s16,
    },
    sectionTitle: {
      fontSize: FontSizes.s12,
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l16,
      color: TextColors.tint2,
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
      padding: `0 ${Spacings.s12} ${Spacings.s8}`,
      display: 'block',
    },
    sectionItems: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s8,
    },
    actionButton: {
      padding: Spacings.s12,
    },
    deleteAccountButton: {
      alignSelf: 'center',
      padding: `${Spacings.s4} ${Spacings.s8}`,
      color: TextColors.tint2,
    },
    versionRow: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s12,
      padding: `${Spacings.s4} ${Spacings.s12} ${Spacings.s8}`,
    },
    versionIcon: {
      width: 16,
      height: 16,
      flexShrink: 0,
      color: TextColors.tint2,
    },
    versionLabel: {
      fontSize: FontSizes.s14,
      color: TextColors.tint2,
      flex: 1,
    },
    versionValue: {
      fontSize: FontSizes.s14,
      color: TextColors.tint2,
    },
    actions: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s8,
      padding: `0 ${Spacings.s12}`,
      marginTop: 'auto',
      marginBottom: Spacings.s16,
      flexShrink: 0,
    },
  },
  { name: 'Settings' }
);

export default useStyles;
